// extracted by mini-css-extract-plugin
export default {"links":"ProductSelector_links__Ys1tF","link":"ProductSelector_link__8fcfJ"};